import React , {FunctionComponent, ReactElement} from 'react';
import { CircleIndicator } from '../../../components/circle-indicator/circle-indicator';
import { AnyObject } from 'common/interfaces';
import { useTheme } from 'styled-components';
import classes from './autocomplete.module.scss';

interface IndicatorElementProps{
    item:AnyObject;
};

export const IndicatorElement:FunctionComponent<IndicatorElementProps> = ({item}:IndicatorElementProps):ReactElement=>{
    const theme = useTheme();
    const green = theme.colors.green;
    const grey = theme.colors.grey500;
    return (
        <div className={classes.list_item_with_status}>
          <div>{typeof item?.identifierStatus === 'number' && <CircleIndicator color={!item.identifierStatus ? green : grey} />}</div>
          <span>{item.label}</span>
        </div>
    )
};